var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "post-op-viewer" },
    [
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "details", attrs: { tab: "Post Operation Detail" } },
            [
              _c("div", { staticClass: "post-op-sections" }, [
                _c("div", { staticClass: "post-op-section" }, [
                  _c("h3", { staticClass: "section-title" }, [
                    _vm._v("General Information"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-group" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("event_available"),
                        ]),
                        _vm._v("Status"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.postOp.Operation_Statu)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("person"),
                        ]),
                        _vm._v("Owner"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.$_.get(_vm.postOp, "Owner.name", ""))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("event"),
                        ]),
                        _vm._v("Operation Date"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(_vm.postOp.Operation_Date))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("contacts"),
                        ]),
                        _vm._v("Contact"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.$_.get(_vm.postOp, "Contact.name", ""))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("person"),
                        ]),
                        _vm._v("Name"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.postOp.Name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("wc"),
                        ]),
                        _vm._v("Gender"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.postOp.Cinsiyet)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("phone"),
                        ]),
                        _vm._v("Phone"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.postOp.Phone)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("email"),
                        ]),
                        _vm._v("Email"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.postOp.Email1)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("local_hospital"),
                        ]),
                        _vm._v("Planted Area"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.postOp.Ekim_B_lgesi.join(", "))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("comment"),
                        ]),
                        _vm._v("Comment Owner"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$_.get(_vm.postOp, "Yorum_Sahibi.name", "")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("link"),
                        ]),
                        _vm._v("Comment Link"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.postOp.Yorum_Link_i,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.postOp.Yorum_Link_i))]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("event"),
                        ]),
                        _vm._v("Comment Date"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.formatDate(_vm.postOp.Yorum_Tarihi))),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "tasks", attrs: { tab: "Tasks" } },
            [
              _c("Tasks", {
                attrs: { module: "Post_Operations", id: _vm.postOp.id },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }